import React from 'react';
import { NewspaperIcon } from 'lucide-react';
interface NewsCardProps {
  title: string;
  source: string;
  excerpt: string;
  imageUrl?: string;
  category: string;
}
export const NewsCard = ({
  title,
  source,
  excerpt,
  imageUrl,
  category
}: NewsCardProps) => {
  return <div className="bg-[#2C2F33] rounded-xl overflow-hidden hover:shadow-lg transition-shadow" data-id="element-79">
      <div className="p-4" data-id="element-80">
        <div className="flex items-center mb-3" data-id="element-81">
          <div className="w-8 h-8 bg-gray-700 rounded-full flex items-center justify-center mr-2" data-id="element-82">
            <NewspaperIcon size={16} className="text-[#F5F5F7]" data-id="element-83" />
          </div>
          <div data-id="element-84">
            <span className="text-[#F5F5F7] font-medium" data-id="element-85">{source}</span>
            <span className="text-gray-400 text-sm ml-2" data-id="element-86">News</span>
          </div>
          <span className="ml-auto bg-gray-700 text-gray-300 px-2 py-0.5 rounded-full text-xs" data-id="element-87">
            {category}
          </span>
        </div>
        <h3 className="text-[#F5F5F7] font-bold text-lg mb-2" data-id="element-88">{title}</h3>
        {imageUrl && <div className="mb-3 rounded-lg overflow-hidden" data-id="element-89">
            <img src={imageUrl} alt={title} className="w-full h-32 object-cover" data-id="element-90" />
          </div>}
        <p className="text-gray-300 text-sm mb-3" data-id="element-91">{excerpt}</p>
        <button className="text-[#007BFF] hover:underline text-sm font-medium" data-id="element-92">
          Read More
        </button>
      </div>
    </div>;
};